import { AuthResponse } from '../../lib/types/models/auth/login'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient, switchSession } from '../rest-api-client'

// Swaps the auth cookies for the other account's: the caller reloads the page once it succeeds
export const connectAsStaff = async (id: number) => {
  return switchSession(() =>
    restApiClient
      .url(constructApiUrl(API.staffs.connect.url, { id }))
      .options({ sessionSwitch: true })
      .post<AuthResponse>()
  )
}
